import {Component, OnInit} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-account-user-guide',
  templateUrl: './account-user-guide.component.html',
  styleUrls: ['./account-user-guide.component.scss']
})
export class AccountUserGuideComponent implements OnInit {

  public url: string;
  public loaded: boolean = false;

  private readonly guideBaseUrl: string = 'https://www.zumex.com/wp-content/uploads/2023/01/zumexconnect_';
  private readonly guideNameEs: string = 'guia_usuario';
  private readonly guideNameEn: string = 'userguide';
  private readonly guideNameDe: string = 'Benutzerhandbuch';
  private readonly guideNameIt: string = 'guida_all_uso';
  private readonly guideNameFr: string = 'guide_de_utilisateur';
  private readonly pdfExt: string = '.pdf';

  private language: string;


  constructor(private readonly i18n: TranslocoService) {
  }

  ngOnInit(): void {
    this.language = this.i18n.getActiveLang();
    const guideName: string = this.getGuideName(this.language);
    this.url = this.guideBaseUrl + guideName + this.pdfExt;
    this.loaded = true;
  }

  private getGuideName(language: string): string {
    switch (language) {
      case 'es':
        return this.guideNameEs;
      case 'en':
        return this.guideNameEn;
      case 'de':
        return this.guideNameDe;
      case 'it':
        return this.guideNameIt;
      default:
        return this.guideNameFr;
    }
  }

}
